export default "__VITE_ASSET__CMWrB2Mc__"